import { Dispatch } from "@reduxjs/toolkit";

import {
  SET_IS_LOADING_FILE,
  SET_IS_PRINT_SERVICE_UNAVAILABLE,
} from "../redux/slices/appSlice";
import fetchFile from "../fetchFile";

export const handlePrintExportFile = async (
  dispatch: Dispatch,
  href: string,
  rel: string,
  authToken: string,
  isToUseAuthZero: boolean
) => {
  dispatch(SET_IS_LOADING_FILE(true));

  const res = await fetchFile(href, rel, authToken, isToUseAuthZero);

  dispatch(SET_IS_LOADING_FILE(false));
  dispatch(SET_IS_PRINT_SERVICE_UNAVAILABLE(!res.ok));
};
